/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { healthControllerCheck } from "./healthControllerCheck";
import { healthControllerDetailed } from "./healthControllerDetailed";

export function healthService() {
  return { healthControllerCheck, healthControllerDetailed }
}